<template>
	<div class="zov-tabs-card-roller">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'zov-tabs-card-roller'
}
</script>
